import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { shiftService } from '../services/shiftService'
import { SHIFT_DETAIL_QUERY_KEY } from '../constants/handoverConstants'
import type { ShiftDetailResponse } from '../types/shift.types'

export function useShiftDetail(shiftId: number | null): UseQueryResult<ShiftDetailResponse> {
  return useQuery<ShiftDetailResponse>({
    queryKey: [SHIFT_DETAIL_QUERY_KEY, { shiftId }],
    queryFn: () => shiftService.getDetail(shiftId as number),
    enabled: shiftId !== null,
    meta: { silent: true, source: 'useShiftDetail' },
  })
}
